
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slack",
      function () {
        return require("private-next-pages/slack.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slack"])
      });
    }
  